import { render, staticRenderFns } from "./CreateCampaignSourceCollections.vue?vue&type=template&id=697b4040&scoped=true"
import script from "./CreateCampaignSourceCollections.vue?vue&type=script&lang=js"
export * from "./CreateCampaignSourceCollections.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignSourceCollections.vue?vue&type=style&index=0&id=697b4040&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697b4040",
  null
  
)

export default component.exports